const defaultSettings = {
    defaultLabelSpan: 24,
    defaultWrapperSpan: 24
}

export default defaultSettings